<template>
  <div>
    <div class="con" v-loading="loading">
      <div class="text item">
        <network-info :network-info="networkInfo" @fetchNetworkInfo="fetchNetworkInfo"></network-info>
        <div class="setting">{{$t('lang.wire.functionConfiguration')}}</div>
        <div class="Table-Con">
          <el-form ref="ruleForm" :model="data" :rules="rules" label-width="250px" class="demo-ruleForm">
            <el-form-item :label="$t('lang.ConfigSetting.OnOff')+'：'" prop="name">
              <el-switch
                v-model="value"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="SwitchChange">
              </el-switch>
            </el-form-item>
            <el-form-item :label="$t('lang.ConfigSetting.disabled')+'：'">
              <el-checkbox class="Form-Input-Width" v-model="data.disabled"></el-checkbox>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.Protocol')}：`" prop="name">
              <el-select
                :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
                v-model="data.proto"
                size="mini"
                class="Form-Input-Width">
                <el-option
                  v-for="item in ProtoList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.VpnServer')}：`" prop="name">
              <el-input size="mini" class="Form-Input-Width" v-model="data.server"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.PapchapUsername')}：`" prop="name">
              <el-input size="mini" class="Form-Input-Width" v-model="data.username"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.PapchapPassword')}：`" prop="name">
              <el-row>
                <el-col :span="18">
                  <el-input size="mini" :type="pwdInputType" class="Form-Input-Width" v-model="data.password"></el-input>
                </el-col>
                <el-col :span="3">
                  <i style="cursor: pointer;" @click="setPWDView()" class="el-icon-view"></i> 
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.PowerOn')}：`" prop="name">
              <el-checkbox class="Form-Input-Width" v-model="data.auto"></el-checkbox>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.UseDefaultGateway')}：`" prop="name">
              <el-row>
                <el-col :span="24">
                  <el-checkbox class="Form-Input-Width" v-model="data.defaultroute"></el-checkbox>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span class="tips">{{$t('lang.L2TP.routeTips')}}</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item  :label="$t('lang.ConfigSetting.UseGatewayHops')+'：'">
              <el-input class="Form-Input-Width" size="mini" placeholder="0" v-model="data.metric"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.MPPEEncryption')}：`" prop="name">
              <el-select
                :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
                v-model="data.mppe"
                size="mini"
                class="Form-Input-Width">
                <el-option
                  v-for="item in MppeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lang.ConfigSetting.useTheDns')" >
              <el-checkbox class="Form-Input-Width" v-model="data.peerdns"></el-checkbox>
              <p style="color: #9e9a9a;font-size:14px;">留空则忽略所通告的 DNS 服务器地址</p>
            </el-form-item>
            <el-form-item v-if="!data.peerdns" :label="$t('lang.ConfigSetting.useTheCustomDns')">
              <add-input :dns="data.dns" @GetAddInput="GetAddInput"></add-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.LCPResponseFailureThreshold')}：`" prop="name">
              <el-row>
                <el-col :span="24">
                  <el-input size="mini" class="Form-Input-Width" v-model="LcpOne"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span class="tips">{{$t('lang.L2TP.LcpOneTips')}}</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.LCPResponseInterval')}：`" prop="name">
              <el-row>
                <el-col :span="24">
                  <el-input size="mini" class="Form-Input-Width" v-model="LcpTwo"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span class="tips">{{$t('lang.L2TP.LcpTwoTips')}}</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item :label="$t('lang.ConfigSetting.activityTimeout')+'：'">
              <el-input class="Form-Input-Width" size="mini" v-model="data.demand" placeholder="0"></el-input>
              <p style="color: #9e9a9a;font-size:14px;">在给定时间（秒）后关闭非活动链接，0 为保持连接</p>
            </el-form-item>
            <el-form-item :label="`${$t('lang.L2TP.assignedAddress')}：`" prop="ipaddr">
              <el-row>
                <el-col :span="24">
                  <el-input size="mini" v-model="data.ipaddr" class="Form-Input-Width"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span class="tips">{{$t('lang.L2TP.ipTips')}}</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item :label="$t('lang.ConfigSetting.resetMTU')+'：'" >
              <el-input class="Form-Input-Width" size="mini" v-model="data.mtu" placeholder="1500"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.AdditionalPPPParameters')}：`" prop="name">
              <add-input :dns="data.pppd_options" @GetAddInput="GetAddInput"></add-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-button type="danger" size="mini" class="Config-Buttom" @click="updateConfig">
        {{$t('lang.ConfigSetting.SaveApply')}}
      </el-button>
    </div>
  </div>
</template>

<script>
import { updateConfig, listConfig, getNetworkInfo } from "@/api/configurationlist";
import AddInput from "../AddInput/index";
import networkInfo from '../networkInfo/index'
import { cloneDeep, isEqual } from 'lodash'
import {getProgressStatus, progressControl} from "../../../../../api/particulars";
export default {
  name: "PPTP",
  props: ["deviceDid", "deviceSn"],
  data(){
     var checkIp = (rule, value, callback) => {
      if(value) {
        console.log(value);
        let ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/
        let domain = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
        let url =/^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/
        let val = value.indexOf(':')
        console.log('val');
        console.log(val);
        if(val === -1) {
          callback(new Error(this.$t('lang.L2TP.assignedAddressError')))
        }else{
         let ipaddr = value.split(':')
         if((ip.test(ipaddr[0]) || domain.test(ipaddr[0]) || url.test(ipaddr[0])) && (ip.test(ipaddr[1]) || domain.test(ipaddr[1]) || url.test(ipaddr[1]))) {
           callback()
         }else{
           callback(new Error(this.$t('lang.L2TP.assignedAddressError')))
         }
        }
      }else{
        callback()
      }
    }
    return{
        loading:true,
        ProtoList:[{value:'pptp',label:'PPTP'}],
        MppeList:[{value:'0',label:'Disable'},{value:'1',label:'Auto'},
            {value:'2',label:'Statefull'},{value:'3',label:'Stateless'}],
        //LCP响应故障阈值
        LcpOne:'',
        //LCP响应间隔
        LcpTwo:'',
        copyLcpOne: '',
        copyLcpTwo: '',
        value:false,
        data: {},
        WatchData: {},
        // 网络接口基本信息
      networkInfo: {},
      timer: null,
      isSwitch: false,
      vpntimer: null,
      // 设置密码是否可见
      pwdInputType: 'password',
      rules: {
        ipaddr: [
          { validator: checkIp, trigger: 'blur'}
        ]
      }
    }
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler(newValue, oldValue) {
        this.getConfig()
        this.fetchNetworkInfo()
      },
    }
  },
  mounted() {
      this.GetVpnStatus()
  },  
  activated() {
    this.fetchNetworkInfo()
    this.timer = setInterval(() => {
      this.fetchNetworkInfo()
    }, 10000)
  },
  deactivated() {
    clearInterval(this.timer)
    clearInterval(this.vpntimer)
  },   
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.vpntimer)
  },
  methods:{
    // 获取lan接口基本信息
    fetchNetworkInfo() {
      getNetworkInfo(this.deviceDid, this.deviceSn, ['pptp1']).then(res => {
        this.networkInfo = res.data.data.mess.pptp1
      })
    },
    //获取配置参数
    getConfig() {
      this.loading = true
      listConfig(this.deviceSn, this.deviceDid, [
        {
          section: "pptp1",
          config: "network",
          options: [
            { option: "proto" },
            { option: "server" },
            { option: "username" },
            { option: "password" },
            { option: "auto" },
            { option: "defaultroute" },
            { option: "mppe" },
            { option: "keepalive" },
            { option: "ipaddr" },
            { option: "pppd_options" },
            { option: "disabled" },//是否禁用
            { option: "metric" },//使用网关跃点
            { option: "peerdns" },//使用对端通告的dns服务器
            { option: "mtu" },//mtu
            { option: "demand" },//超时
            { option: "dns" },//dns
          ]
        }
      ]).then(res => {
        this.data = res.data.data.mess[0].s_objects[0].options;
        //添加默认配置参数,将复选框值转换成布尔值
        this.data.auto=this.data.auto=='1'?true:false
        this.data.defaultroute=this.data.defaultroute=='0'?false:true
        this.data.disabled = this.data.disabled=='0'?false:true
        this.data.peerdns = this.data.peerdns=='0'?false:true
        //添加配置参数为空的默认值
        this.data.mppe=this.data.mppe==''?'3':this.data.mppe
        this.data.keepalive=this.data.keepalive==''?this.data.keepalive='5 3':this.data.keepalive
        //获取 LCP响应故障阈值 和LCP响应间隔
        if(this.LcpOne==''){
            this.LcpOne=this.data.keepalive.split(' ')[0]
            this.copyLcpOne = cloneDeep(this.LcpOne)
        } 
        if(this.LcpTwo==''){
            this.LcpTwo=this.data.keepalive.split(' ')[1]
            this.copyLcpTwo = cloneDeep(this.LcpTwo)
        }
        this.WatchData = cloneDeep(this.data)
        this.loading = false
        this.isSwitch = false
        clearInterval(this.vpntimer)
        clearInterval(this.timer)
        this.timer = setInterval(() =>{
          this.fetchNetworkInfo()
        }, 10000)
      }).catch(err => {
        if(!this.isSwitch) { // 不是点击启用/停用/保存应用做的操作
          this.$message({
            message: this.$t('lang.request.timeout'),
            type: "warning"
          })
        }
      })
    },
    //接收AddInput的改变传过来的值
    GetAddInput(props) {
        this.data.pppd_options = props
    },
    //获取vpn运行状态
    GetVpnStatus(){
      getProgressStatus(this.deviceDid,this.deviceSn,{network:['pptp1']}).then((res)=>{
        this.value=res.data.data.mess[0].status==1?true:false
      })
    },
    //Vpn开关切换
    SwitchChange(e){
      // this.data={}
      this.isSwitch = true
      clearInterval(this.vpntimer)
      // 清除之前的请求，不然当用户频繁切换开关的时候会导致切换几次就会进行请求刷新好几次
      // 清除之前的只执行最新的一次请求
      this.$store.dispatch('clearToken')
     
      progressControl([
          { process:'pptp1',
            type:1,
            action:e?'start':'stop'
          }
        ],
        this.deviceDid.toString(),
        this.deviceSn
      ).then(res => {
        clearInterval(this.timer)
        this.vpntimer = setInterval(() => {
          this.GetVpnStatus()
          this.getConfig()
          this.fetchNetworkInfo()
        }, 10000)
      })
    },
    // 密码是否可见
    setPWDView() {
      if(this.pwdInputType === 'password') {
        this.pwdInputType = ''
      }else{
        this.pwdInputType = 'password'
      }
    },
    //保存配置
    updateConfig(){
      // 校验表单
      this.$refs['ruleForm'].validate((valid) =>{
        if(valid) {
          if(!isEqual(this.data, this.WatchData) || !isEqual(this.copyLcpTwo, this.LcpTwo) || !isEqual(this.copyLcpOne, this.LcpOne)) {
            //保存配置时转换
            this.data.auto=this.data.auto?'1':'0'
            this.data.defaultroute=!this.data.defaultroute?'0':''
            this.data.keepalive=this.LcpOne+' '+this.LcpTwo
            this.data.disabled = this.data.disabled?'1':'0'
            this.data.peerdns = this.data.peerdns?'1':'0'
            const data=this.data
            // 清除之前的只执行最新的一次请求
            this.$store.dispatch('clearToken')
            // 清空之前的定时器，防止切换开关的同时保存修改，那么会有多个计时器，将会一直在刷新
            clearInterval(this.timer)
            clearInterval(this.vpntimer)
            updateConfig(this.deviceSn, this.deviceDid,[
              {
                  section: "pptp1",
                  config: "network",
                  action: 0,
                  index: [0],
                  options: {
                      ...data
                  }
              }
            ]).then(res => {
                if (res.data.data.mess === 0) {
                  this.loading = true
                  progressControl([
                      { process:'pptp1',
                        type:1,
                        action:'restart'
                      }
                    ],
                    this.deviceDid.toString(),
                    this.deviceSn
                  ).then(res => {
                    this.$message({
                      showClose: true,
                      message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
                      type: "success"
                    });
                    // this.data={}
                    clearInterval(this.timer)
                    
                    this.vpntimer = setInterval(() => {
                      this.GetVpnStatus()
                      this.getConfig()
                      this.fetchNetworkInfo()
                    }, 10000)
                  })
                }else {
                  this.$message({
                      showClose: true,
                      message: this.$t('lang.ConfigSetting.Configurationerror'),
                      type: "warning"
                  });
                  return;
                }
            }).catch((err)=>{
              console.log('请求超时')
              console.log(err)
            })
          }else{
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Nochangesmade'),
              type: 'warning'
            });
            return
          }
        }else{
          return false
        }
      }) 
    }
  },
  components:{
    AddInput,
    networkInfo
  }
}
</script>
<style src='../common.css' scoped></style>

